/* What the chart tools are called right now.
 *
 * ═══ WHY THESE ARE NOT WRITTEN WHERE THEY ARE SHOWN ═══
 *
 * These labels are STATE, not decoration. `MEASURE` becomes `TAP TWO POINTS`
 * because "tap two points" is not something a chart can imply, and `AUTOROUTE`
 * becomes `TAP THE START` because an armed tool with no indicator is a mode you
 * cannot see. On a phone that state is shown in two places at once — the dock's
 * third slot while a tool is armed, and the row inside the tools sheet — and
 * two copies of a string that says what the app is waiting for is two copies
 * that will eventually disagree about it.
 */
import { measure } from '@gennetay/chart-core/lib/measure.svelte';
import { autoroute } from '@gennetay/chart-core/lib/autoroute.svelte';
import { routePlan } from '@gennetay/chart-core/lib/routeplan.svelte';

export function routeLabel(): string {
  if (routePlan.mode === 'start') return 'TAP THE START';
  if (routePlan.mode === 'end') return 'TAP THE END';
  if (autoroute.computing) return 'SOLVING…';
  return 'AUTOROUTE';
}

export function measureLabel(): string {
  if (!measure.active) return 'MEASURE';
  return measure.a && measure.b ? 'MEASURE ✕' : 'TAP TWO POINTS';
}

/**
 * The label for whichever tool is waiting on a tap, or null when the chart is
 * just a chart.
 *
 * 3D is deliberately absent: it changes how the chart LOOKS, not what a tap on
 * it does, so it does not need to be shouted from the dock. It shows as a lit
 * row in the tools sheet like any other setting.
 */
export function armedLabel(): string | null {
  if (routePlan.armed) return routeLabel();
  if (measure.active) return measureLabel();
  return null;
}

/** Stand every tool down — what tapping the dock's armed slot does. */
export function disarmAll(): void {
  if (routePlan.armed) routePlan.off();
  if (measure.active) measure.toggle();
}
